import { ErrorHandler, Injectable, inject } from '@angular/core';
import { ErrorLogDbService } from '../db/error-log.db.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  private errorService = inject(ErrorLogDbService);

  handleError(error: unknown): void {

    console.error('Global Error:', error);

    let message = 'Unknown error';
    let stack = '';

    if (error instanceof Error) {
      message = error.message;
      stack = error.stack || JSON.stringify(error);
    } else {
      try {
        stack = JSON.stringify(error);
      } catch {
        stack = String(error);
      }
    }

    this.errorService.log({
      message,
      stack,
      date: new Date().toISOString(),
      url: window.location.href
    });

  }
}
